import echarts from 'echarts';
import scroll from 'vue-seamless-scroll';
import { getAllMarketId, getMonies, getWebBannerList, getMarkets, get24hKline } from '@/utils/market';
import { sendWebSocketObj } from '@/utils/websocket';
import Footer from '@/components/common/Footer';
import Config from '@/utils/Config';

const deepcopy = require('deepcopy');

export default {
    name: 'Index',
    components: {
        Footer,
        'vue-seamless-scroll': scroll,
    },
    data() {
        return {
            Config,
            sortType: 'asc',
            marketsData: [],
            sliders: [],
            renderedKlineMarkets: {},
            scrollShow: false,
            sliderIndex: 0,
            processWidth: 0,
        };
    },
    computed: {
        webSocketIsConnected() {
            return this.$store.state.socket.isConnected;
        },
        priceUSD() {
            return this.$store.state.priceUSD;
        },
        markets() {
            return this.marketsData.filter(item => parseFloat(item.today.last) > 0);
        },
        newMarketData() {
            return this.$store.state.newMarketData;
        },
        optionLeft() {
            return {
                step: 1,
                direction: 2,
            };
        },
    },
    watch: {
        newMarketData(n) {
            const self = this;
            const data = n;
            const key = data[0];
            const value = deepcopy(data[1]);
            // covert today data
            self.marketsData = self.marketsData.map((v) => {
                const market = v;
                if (v.symbol == key.toString()) {
                    if (value.change != '-1') {
                        value.change = parseFloat((value.change - 1) * 100);
                    } else {
                        value.change = 0;
                    }
                    if (v.today.last == 0 && parseFloat(value.last) > 0) {
                        market.today = value;
                    }
                    market.today = value;
                }
                return market;
            });
            setTimeout(() => {
                self.markets.forEach((market) => {
                    if (!self.renderedKlineMarkets[market.symbol] && market.today.change != 0) {
                        self.renderLine(`${market.symbol}_line`, market.kline, market.today.change);
                    }
                    self.renderedKlineMarkets[market.symbol] = true;
                });
            }, 2000);
        },
    },
    mounted() {
        const self = this;
        getMarkets().then((markets) => {
            let marketsData = markets;
            marketsData = markets.map((item) => {
                const market = item;
                market.today = { change: 0, volume: 0, last: 0 };
                return market;
            });
            get24hKline().then((res) => {
                marketsData = marketsData.map((item) => {
                    const market = item;
                    for (let i = 0; i < res.length; i += 1) {
                        if (res[i].symbol == item.symbol && parseFloat(res[i].data[0][5]) > 0) {
                            market.kline = res[i].data.map(kline => parseFloat(kline[1]));
                        }
                    }
                    return market;
                });
                self.marketsData = markets;
                sendWebSocketObj(this, 'today', getAllMarketId(this.marketsData));
                sendWebSocketObj(this, 'cash', [getMonies(this.marketsData).join('/'), 'CNY/USD']);
            });
        });
        getWebBannerList().then((res) => {
            if (res.code === 0) {
                self.sliders = self.group(res.result, 4);

                if (self.sliders.length > 1) {
                    setInterval(() => {
                        if (self.processWidth > 40) {
                            self.processWidth = 0;
                            if (self.sliderIndex === (self.sliders.length - 1)) {
                                self.sliderIndex = 0;
                            } else {
                                self.sliderIndex += 1;
                            }
                        } else {
                            self.processWidth += 0.3478;
                        }
                    }, 200);
                }
            }
        });
    },
    methods: {
        goto(path) {
            window.open(path, '_blank');
        },
        sortMarket(sortAttr) {
            const self = this;
            self.marketsData = self.marketsData.sort((f, s) => {
                if (self.sortType === 'asc') {
                    return parseFloat(f.today[sortAttr]) - parseFloat(s.today[sortAttr]);
                }
                return parseFloat(s.today[sortAttr]) - parseFloat(f.today[sortAttr]);
            });
            if (this.sortType === 'asc') {
                this.sortType = 'desc';
            } else {
                this.sortType = 'asc';
            }
        },

        group(array, subGroupLength) {
            let index = 0;
            const newArray = [];

            while (index < array.length) {
                newArray.push(array.slice(index, index += subGroupLength));
            }
            return newArray;
        },
        renderLine(id, kline, change) {
            let color = '#E96975';
            if (parseFloat(change) > 0) {
                color = '#3BBD89';
            }
            const elements = document.getElementsByClassName(id);
            for (let i = 0; i < elements.length; i += 1) {
                const myChart = echarts.init(elements[i]);
                const option = {
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        show: false,
                    },
                    yAxis: {
                        min: Math.min(kline),
                        max: Math.max(kline),
                        type: 'value',
                        show: false,
                    },
                    series: [{
                        smooth: true,
                        symbol: 'none',
                        data: kline,
                        type: 'line',
                        lineStyle: { color },
                        areaStyle: { opacity: 0 },
                    }],
                    grid: {
                        left: '0%',
                        right: '0%',
                        top: '0%',
                        bottom: '0%',
                    },

                };
                myChart.setOption(option);
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/views/index.js